import React, { useEffect, useRef, useState } from 'react';
import {
    buildIRLEvidenceStagePlan,
    pickIRLEvidenceActiveMessage,
} from '../../utils/irlEvidencePipelineLoader';
import styles from './irlEvidence.module.css';

const IRLEvidencePipelineLoader = ({ active }) => {
    const stagePlan = React.useMemo(() => buildIRLEvidenceStagePlan(), []);
    const [stageIndex, setStageIndex] = useState(0);
    const [messageTick, setMessageTick] = useState(0);
    const runIdRef = useRef(0);

    useEffect(() => {
        if (!active) {
            setStageIndex(0);
            setMessageTick(0);
            return undefined;
        }

        const runId = ++runIdRef.current;
        let idx = 0;
        let timeoutId;

        const advance = () => {
            if (runIdRef.current !== runId) return;
            const stage = stagePlan[idx];
            if (!stage) return;
            setStageIndex(idx);
            timeoutId = window.setTimeout(() => {
                if (runIdRef.current !== runId) return;
                idx += 1;
                if (idx < stagePlan.length) {
                    advance();
                } else {
                    setStageIndex(stagePlan.length - 1);
                }
            }, stage.durationMs);
        };

        advance();
        const msgInterval = window.setInterval(() => setMessageTick(t => t + 1), 1400);

        return () => {
            window.clearTimeout(timeoutId);
            window.clearInterval(msgInterval);
        };
    }, [active, stagePlan]);

    if (!active) return null;

    const currentStage = stagePlan[Math.min(stageIndex, stagePlan.length - 1)] || stagePlan[0];
    const activeMessage = pickIRLEvidenceActiveMessage(currentStage, messageTick);

    return (
        <section className={styles.pipelineLoader} aria-busy="true" aria-label="Evidence validation in progress">
            <p className={styles.pipelineActiveMessage}>{activeMessage}</p>
            <ol className={styles.pipelineStages}>
                {stagePlan.map((stage, i) => {
                    const status = i < stageIndex ? 'done' : i === stageIndex ? 'active' : 'pending';
                    return (
                        <li key={stage.id} className={styles.pipelineStage} data-status={status}>
                            <span className={styles.pipelineStageDot} aria-hidden />
                            <span className={styles.pipelineStageLabel}>{stage.label}</span>
                        </li>
                    );
                })}
            </ol>
        </section>
    );
};

export default IRLEvidencePipelineLoader;
